/* ============================================================
   NORVA NEXT — site-wide interaction layer
   Lazy images fade in as they finish loading, so pages feel
   like they compose themselves rather than pop into place.
   ============================================================ */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function arm(img) {
    if (img.complete || img.dataset.norvaFade) return;
    img.dataset.norvaFade = '1';
    img.classList.add('norva-fade-wait');
    var reveal = function () {
      img.classList.add('norva-fade-in');
      img.classList.remove('norva-fade-wait');
    };
    img.addEventListener('load', reveal, { once: true });
    img.addEventListener('error', reveal, { once: true });
  }

  document.querySelectorAll('img[loading="lazy"]').forEach(arm);

  /* Catch images injected later (cart drawer re-renders, sliders, quick add) */
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('img[loading="lazy"]')) arm(node);
        if (node.querySelectorAll) {
          node.querySelectorAll('img[loading="lazy"]').forEach(arm);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
